module.exports = "../../app/cells/components/campaigns/interventions/top_bar/show.erb";